import React from "react";

const LogoBlockStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.74995 2C6.41254 2 6.11668 2.2253 6.02695 2.55055L2.02695 17.0506C1.9168 17.4499 2.1512 17.8628 2.5505 17.973C2.9498 18.0831 3.36279 17.8487 3.47294 17.4494L4.42451 14H8.31165L9.0155 17.402C9.08756 17.7502 9.3943 18 9.74995 18H17.2499C17.4755 18 17.6891 17.8985 17.8315 17.7236C17.974 17.5487 18.0301 17.3189 17.9844 17.098L14.9844 2.59805C14.9123 2.24978 14.6056 2 14.2499 2H6.74995ZM8.0013 12.5L6.64573 5.94808L4.8383 12.5H8.0013ZM10.3607 16.5L7.671 3.5H13.6392L16.3289 16.5H10.3607Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(LogoBlockStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;